/**
 * What the messenger is currently doing, mirrored from Intercom's callbacks.
 *
 * Module scope rather than React state on purpose: there is one global widget,
 * several unrelated components ask about it, and a re-boot has to be able to
 * restore what was true before. Note this makes the module HMR-hostile — an
 * edit resets these while the widget keeps its real state, so dev-server
 * observations after a hot reload are not trustworthy.
 */

let messengerOpen = false;
let unreadCount = 0;

const shownListeners = new Set<() => void>();

export const isMessengerOpen = () => messengerOpen;
export const getUnreadCount = () => unreadCount;

export function setMessengerOpen(open: boolean) {
  messengerOpen = open;
  if (open) shownListeners.forEach((listener) => listener());
}

export function setUnreadCount(count: number) {
  unreadCount = count;
}

/**
 * Fires when the panel opens. `onShow` is the only trustworthy confirmation
 * that a `show()` actually landed — see useIntercom's fallback.
 */
export function onMessengerShown(listener: () => void) {
  shownListeners.add(listener);
  return () => shownListeners.delete(listener);
}

/** Called when a session is torn down; the next one reports its own state. */
export function resetMessengerState() {
  messengerOpen = false;
  unreadCount = 0;
}
